<template>
    <resource-index title="Продления" :endpoint="endpoint">
        <template v-slot:table-header>
            <tr class="border-b">
                <th class="text-left p-3 px-5" scope="col">Начало</th>
                <th class="text-left p-3 px-5" scope="col">Окончание</th>
                <th class="text-left p-3 px-5" scope="col">Стоимость</th>
                <th class="text-left p-3 px-5" scope="col"></th>
            </tr>
        </template>

        <template v-slot:row="slotProps">
            
            <td class="p-3 px-5">
                {{ localTime(slotProps.entry.starts_at) }}
            </td>

            <td class="p-3 px-5">
                {{ localTime(slotProps.entry.ends_at) }}
            </td>

            <td class="p-3 px-5">
                <span class="badge whitespace-no-wrap badge-success">
                    {{ slotProps.entry.amount }} ₽
                </span>
            </td>

            <td class="p-3 px-5">
                <router-link
                    :to="{
                        name: 'admin.billing.rentals.edit',
                        params: {
                            id: slotProps.entry.id
                        }
                    }"
                    class="btn btn-info">Изменить</router-link>
            </td>
        </template>
    </resource-index>
</template>

<script>
    import ResourceIndex from '@/components/Resource/ResourceIndex';
    import qs from 'qs';
    
    export default {
        components: {
            ResourceIndex,
        },

        data () {
            return {
                endpoint: `/admin/billing/rentals/${this.$route.params.id}/renewals`
            }
        },
    }
</script>